import { EarthBoxRemoveIcon } from './EarthBoxRemoveIcon';

/**
 * author: Muhammet Balsoy
 * id A7F1974D-8084-4EBF-A932-2051938CB985
 * name earth-box-remove
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-box-remove.svg
 * tags
 * - Navigation 
 */
export const WorldBoxRemoveIcon = EarthBoxRemoveIcon;
export default WorldBoxRemoveIcon